import React from 'react';
import PropTypes from 'prop-types';

import {Box, Paper, Skeleton, Stack} from 'views/components';

const CardGridSkeleton = (props) => {
  const {
    cardCount = 4,
    gridTemplateColumns = {xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(4, minmax(0, 1fr))'},
  } = props;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns,
        gap: 1.75,
      }}
    >
      {
        Array.from({length: cardCount}).map((x, index) => {
          return (
            <Paper
              key={index}
              sx={{
                p: 2.5,
                borderRadius: '8px',
                border: '1px solid #E5E5E5',
                boxShadow: 'none',
              }}
            >
              <Stack spacing={1.5}>
                <Box sx={{minWidth: 0}}>
                  <Skeleton variant='text' width='60%' height={20} />
                  <Skeleton variant='text' width='40%' height={42} />
                </Box>
                <Box sx={{borderTop: '1px solid #EAEAEA'}} />
                <Stack direction='row' spacing={1} alignItems='center'>
                  <Skeleton variant='rounded' width={64} height={22} />
                  <Skeleton variant='text' width='32%' height={18} />
                </Stack>
              </Stack>
            </Paper>
          );
        })
      }
    </Box>
  );
};

CardGridSkeleton.propTypes = {
  cardCount: PropTypes.number,
  gridTemplateColumns: PropTypes.object,
};

export default React.memo(CardGridSkeleton);
